import {
  defineNuxtPlugin,
  onGlobalSetup,
  useRoute,
} from '@nuxtjs/composition-api';
import { useRouter } from 'vue-router/composables';

import type { Context } from '@nuxt/types';

let nuxtApp: Context | undefined;
let route: ReturnType<typeof useRoute> | undefined;
let router: ReturnType<typeof useRouter> | undefined;

export default defineNuxtPlugin((_nuxtApp: Context) => {
  nuxtApp = _nuxtApp;
  onGlobalSetup(() => {
    route = useRoute();
    router = useRouter();
  });
});

export const useVuexStore = (): NonNullable<typeof nuxtApp>['store'] => {
  if (!nuxtApp?.store) {
    throw new Error('Vuex Store is not defined :(');
  }

  return nuxtApp?.store;
};

/**
 * В отличие от useContext, работает даже вне setup контекста
 */
export const useIsomorphicContext = (): Context => nuxtApp!;

export const useIsomorphicRoute = () => route!;
export const useIsomorphicRouter = () => router!;
